import { mergeMessages } from './teamChat.transform'
import type { TeamMessage, TeamUser } from './teamChat.types'

// Client ids count down from the top so a pending bubble always sorts after server messages.
let nextPendingId = Number.MAX_SAFE_INTEGER

export const pendingMessage = (body: string, me: TeamUser, createdAt: string): TeamMessage => ({
  id: nextPendingId--,
  type: 'text',
  body,
  user: me,
  is_mine: true,
  request_id: null,
  event_verb: null,
  mention_user_ids: [],
  mentions_me: false,
  created_at: createdAt,
  pending: true,
})

export const settlePending = (
  messages: TeamMessage[],
  pendingId: number,
  confirmed: TeamMessage[],
): TeamMessage[] =>
  mergeMessages(
    messages.filter((m) => m.id !== pendingId),
    confirmed,
  )

export const lastConfirmedId = (messages: TeamMessage[]): number | undefined =>
  messages.findLast((m) => !m.pending)?.id

// The live echo of my own message can beat the HTTP answer; it takes over the matching bubble.
export const dropEchoedPending = (
  current: TeamMessage[],
  incoming: TeamMessage[],
): TeamMessage[] => {
  const echoed = new Set(incoming.filter((m) => m.is_mine && !m.pending).map((m) => m.body))
  const firstPendingFor = new Map<string, number>()
  current.forEach((m) => {
    if (m.pending && echoed.has(m.body) && !firstPendingFor.has(m.body))
      firstPendingFor.set(m.body, m.id)
  })
  const dropped = new Set(firstPendingFor.values())
  return current.filter((m) => !dropped.has(m.id))
}
